import { randomNumber } from '../../../../utilities'
import { RescueConstants } from './rescue.constants'
import { IRescueAction, IRescueState } from './rescue.types'

export const initialRescueState: IRescueState = {
  rescueTypes: [],
  hydraulics: [],
  tools: [],
  rehab: [],
  activations: [],
  size: '',
  assessedBy: null,
  procedureComplications: [],
  response: null,
  responsePNNV: null,
  authorization: null,
  comments: '',
  addToTimeline: false,
  updateInputRows: false,
  key: randomNumber().toString(),
  date: '',
  time: '',
  successfulAttempt: true,
  pta: false,
  attempts: '1',
  type: 'Rescue',
  rolePerforming: null,
  rolePerformingPNNV: null,
  procedurePerformedByAnotherUnit: null,
  procedurePerformedByAnotherUnitPNNV: null,
  isEkgImport: null,
  nemsisCode: null,
}

export function rescueReducer(state: IRescueState = initialRescueState, action: IRescueAction): IRescueState {
  switch (action.type) {
    case RescueConstants.SET_TYPES:
      return { ...state, rescueTypes: action.rescueTypes }
    case RescueConstants.SET_HYDRAULICS:
      return { ...state, hydraulics: action.hydraulics }
    case RescueConstants.SET_TOOLS:
      return { ...state, tools: action.tools }
    case RescueConstants.SET_REHAB:
      return { ...state, rehab: action.rehab }
    case RescueConstants.SET_ACTIVATIONS:
      return { ...state, activations: action.activations }
    case RescueConstants.SET_SIZE:
      return { ...state, size: action.size }
    case RescueConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case RescueConstants.SET_DATE:
      return { ...state, date: action.date }
    case RescueConstants.SET_TIME:
      return { ...state, time: action.time }
    case RescueConstants.SET_ASSESSED_BY:
      return { ...state, assessedBy: action.assessedBy }
    case RescueConstants.SET_SUCCESSFUL_ATTEMPT:
      return { ...state, successfulAttempt: action.successfulAttempt }
    case RescueConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case RescueConstants.SET_PROCEDURE_COMPLICATIONS:
      return { ...state, procedureComplications: action.procedureComplications }
    case RescueConstants.SET_RESPONSE:
      return { ...state, response: action.response }
    case RescueConstants.SET_RESPONSE_PNNV:
      return { ...state, responsePNNV: action.responsePNNV }
    case RescueConstants.SET_AUTHORIZATION:
      return { ...state, authorization: action.authorization }
    case RescueConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case RescueConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case RescueConstants.SET_UPDATE_INPUT_ROWS:
      return { ...state, updateInputRows: action.updateInputRows }
    case RescueConstants.SET_STATE:
      return { ...action.rescueState, updateInputRows: true }
    case RescueConstants.SET_ATTEMPTS:
      return { ...state, attempts: action.attempts }
    case RescueConstants.SET_ROLE_PERFORMING:
      return { ...state, rolePerforming: action.rolePerforming }
    case RescueConstants.SET_ROLE_PERFORMING_PNNV:
      return { ...state, rolePerformingPNNV: action.rolePerformingPNNV }
    case RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT:
      return { ...state, procedurePerformedByAnotherUnit: action.procedurePerformedByAnotherUnit }
    case RescueConstants.SET_PROCEDURE_PERFORMED_BY_ANOTHER_UNIT_PNNV:
      return { ...state, procedurePerformedByAnotherUnitPNNV: action.procedurePerformedByAnotherUnitPNNV }
    case RescueConstants.RESET_STATE:
      return {
        rescueTypes: [],
        hydraulics: [],
        tools: [],
        rehab: [],
        activations: [],
        size: '',
        assessedBy: null,
        procedureComplications: [],
        response: null,
        responsePNNV: null,
        authorization: null,
        comments: '',
        addToTimeline: false,
        updateInputRows: true,
        key: randomNumber().toString(),
        date: '',
        time: '',
        successfulAttempt: true,
        pta: false,
        attempts: '1',
        type: 'Rescue',
        rolePerforming: null,
        rolePerformingPNNV: null,
        procedurePerformedByAnotherUnit: null,
        procedurePerformedByAnotherUnitPNNV: null,
        isEkgImport: null,
        nemsisCode: null,
      }
    default:
      return state
  }
}
